import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.652 3.874a2 2 0 0 1 2.697 0l.001.001 9.997 9.085.015.013A2.04 2.04 0 0 1 28 14.422V26h2a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2h2V14.422a2.04 2.04 0 0 1 .638-1.449l.014-.013 9.998-9.085zM14 26h4v-6h-4zm6 0v-6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6H6V14.451a.04.04 0 0 1 .01-.021l9.988-9.077L16 5.35l.003.002 9.988 9.077.006.01.003.011v11.55z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconHomeowners = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconHomeowners);
export default Memo;
